import React, { Component } from "react";

import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Row } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../actions/baseActions";
import { setObj } from "../../../actions/noteActions";
import URL from "../../../config/api";
import axios from "../../../config/axios";
import Filters from "../../Filter/filters";
import Loading from "../../Loading";
import DataTable from "../../Tables/tables";

import "./styles.css";

class PageOfflineList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      // user: {},
      // updated: false,
      searched: false,
      lastRole: null,
      lastGroup: null,
      lastRegion: null,
      lastSchool: null
      // passwordModal: { show: false, id: null }
    };
    this.filter = this.filter.bind(this);
    this.insertUser = this.insertUser.bind(this);
  }

  mountFilter() {
    const group = this.props.general.active_roles.group_id;
    const region = this.props.general.active_roles.region_id;

    if (group === null) {
      // grupo,regiao,escola
    }
    if (group != null) {
      // regiao,escola
    }
    if (region != null) {
      // escola
    }
  }

  setComponent() {
    const role = this.props.general.active_roles.role_id;
    const group = this.props.general.active_roles.group_id;
    const region = this.props.general.active_roles.region_id;
    const school = this.props.general.active_roles.school_id;

    this.setState(
      () => ({
        // user: this.props.user,
        active_roles: {
          role_id: role,
          group_id: group,
          region_id: region,
          school_id: school
        },
        searched: true
      }),
      () => {
        this.filter("", group, region, school);
      }
    );
  }

  componentDidMount() {
    // role_id = 1 é adm educandus
    // role_id = 4 é adm escolar
    axios
      .get(`${URL.api}offline/register/list`, {
        params: {
          group_id: this.state.active_roles.group_id,
          region_id: this.state.active_roles.region_id,
          school_id: this.state.active_roles.school_id
        },
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.success) {
            this.setState(
              () => ({
                list: null
              }),
              () => {
                if (resp.data.data.length === 0) {
                  this.setState(() => ({
                    list: [],
                    searched: false
                  }));
                } else {
                  this.setState(
                    () => ({
                      list: resp.data.data,
                      searched: false
                    }),
                    () => {
                      this.forceUpdate();
                    }
                  );
                }
              }
            );
          } else {
            this.props.logout(this.props.user.token);
          }
        },
        error => {
          if (error.response.statusText === "Unauthorized") {
            this.props.logout(this.props.user.token);
          }
        }
      );
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    this.setComponent();
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillUpdate(nextProps) {
    let searchController = false;

    if (
      nextProps.general.active_roles.school_id !==
      this.state.active_roles.school_id
    ) {
      searchController = true;
    } else if (
      nextProps.general.active_roles.region_id !==
      this.state.active_roles.region_id
    ) {
      searchController = true;
    } else if (
      nextProps.general.active_roles.group_id !==
      this.state.active_roles.group_id
    ) {
      searchController = true;
    } else if (
      nextProps.general.active_roles.role_id !== this.state.active_roles.role_id
    ) {
      searchController = true;
    }

    if (searchController && !this.state.searched) {
      searchController = false;
      this.setState(
        () => ({
          searched: true
        }),
        () => {
          this.setComponent();
          this.mountFilter();
        }
      );
    }
  }

  getSchoolInformations(schoolId) {
    axios
      .get(`${URL.api}offline/register/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` },
        params: { school_id: schoolId }
      })
      .then(
        resp => {
          if (resp.data.success) {
            this.setState(
              () => ({
                list: null
              }),
              () => {
                if (resp.data.data.length === 0) {
                  this.setState(() => ({
                    list: [],
                    searched: false
                  }));
                } else {
                  this.setState(
                    () => ({
                      list: resp.data.data,
                      searched: false
                    }),
                    () => {
                      this.forceUpdate();
                    }
                  );
                }
              }
            );
          } else {
            this.props.logout(this.props.user.token);
          }
        },
        error => {
          if (error.response.statusText === "Unauthorized") {
            this.props.logout(this.props.user.token);
          }
        }
      );
  }

  filter(role = null, group = null, region = null, school = null) {
    this.setState(
      () => ({
        searched: true
      }),
      () => {
        let obj = {};
        if (role !== null || role !== "") {
          obj.role = role;
          this.setState({ lastRole: role });
        }
        if (group !== null || group !== "") {
          obj.group = group;
          this.setState({ lastGroup: group });
        }
        if (region !== null || region !== "") {
          obj.region = region;
          this.setState({ lastRegion: region });
        }
        if (school !== null) {
          obj.school = school;
          this.setState({ lastSchool: school });
          this.getSchoolInformations(obj.school);
        }
      }
    );
  }

  insertUser() {
    this.props.history.push("/offline/register/create");
  }

  error(response) {
    toastr.error("Falha", response);
  }

  deleteRegister(rows) {
    const obj = {
      registers: rows
    };

    let newList = [];

    this.state.list.forEach((item, index) => {
      if (!rows.includes(item.id)) {
        newList.push(item);
      }
    });

    axios
      .post(`${URL.api}offline/register/deleteMany`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          // this.setComponent()
          this.filter(
            this.state.lastRole,
            this.state.lastGroup,
            this.state.lastRegion,
            this.state.lastSchool
          );
          this.setState({ list: newList }, () => {
            this.forceUpdate();
          });
        },
        () => {
          this.error("Não foi possível apagar os usuários");
        }
      );
  }

  render() {
    return (
      <div className="animated fadeIn" style={{ padding: "1.0rem" }}>
        <Row>
          <Filters
            key={JSON.stringify(this.props.general.active_roles)}
            initial="group"
            type="hierarchy"
            group
            region
            school
            action={this.filter}
          />
          {this.state.list ? (
            <div id="list">
              <DataTable
                list={this.state.list}
                path="/offline/register/edit/"
                title="Registros Offline"
                header={[
                  { name: "id", denomination: "ID" },
                  { name: "school_name", denomination: "Escola" },
                  { name: "date", denomination: "Data" },
                  { name: "user_name", denomination: "Responsável" }
                ]}
                // insert
                delete
                action
                btnEdit
                insertAction={this.insertUser}
                deleteAction={ids => this.deleteRegister(ids)}
                btnView
                viewPath="/offline/register/view/"
              />
            </div>
          ) : (
            <Loading />
          )}
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(PageOfflineList);
